import React from 'react';

import { makeStyles } from '@material-ui/styles';

import { Grid} from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

import {blueGrey} from '@material-ui/core/colors';

import theme from '../theme';
import { RoundedCorner } from '@material-ui/icons';
import { useImagePath } from '../hooks/paths';

const useStyles = makeStyles((theme) => ({

  root: {
    display: 'flex',
    justifyContent: 'center',
    margin: theme.spacing(0,0,1,0),
    // backgroundColor:'red'
  },

  row: {
    width: "100%",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    //backgroundColor:'red'
  },

  featured: {
    width: "100%",
    margin: theme.spacing(2,2,0,2),
    [theme.breakpoints.up('md')]: {
      width: "80%",
      margin: theme.spacing(2,1,0,1),
    },
  },

  image: {
    width: 150,
    height: 'auto',
  },

  card: {
    width:"100%",
    display: 'flex',
    justifyContent: 'center',
    flexDirection:  'row',
    backgroundColor: theme.palette.background.whatsapp,
    borderRadius:16,
    boxShadow: theme.boxShadow.image,
    cursor: 'pointer'
  },


  image: {
    width: "80px",
    margin: theme.spacing(1,1,1,1),
  },

  content: {
    display:'flex',
    flexDirection:'column',
    width:"100%",
    margin: theme.spacing(1,1,1,0),
  },

}));




export default function WhatsAppCard(props) {
  const classes = useStyles();
  const imagePath = useImagePath(); 
  const imageUrl = `${ imagePath}/whatsapp.svg`; 
  const { title, subtitle, onClick} = props

  const handlerOnClick = ()=>{
    if(onClick){
      onClick(); 
    }
  }

  return (
    
    <div className={classes.root}>
      <Grid item xs={12} sm={7} >
      <div className={classes.row}>  
      <div className={classes.featured}>  
          <div  className = {classes.card} onClick={handlerOnClick}>

             <img className={classes.image} src={imageUrl} alt={"image"} />
           
             <div  className={classes.content}>
                  {
                  <Typography variant="h5" mx={1} color="primary">
                  {title}
                  </Typography> 
                  }
                  <Typography variant="body"mx={1}  color="primary">
                  {subtitle}
                  </Typography>
             </div>      
        </div>
    </div>
    </div>
    </Grid>
    </div>
  )
}